export default __webpack_public_path__ + "static/media/success.3c9d47af.jpg";